

import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { environment } from '../../../environments/environment';
//import { CreatePassword } from '../createpassword/createpassword.model';
//import { ChangePassword } from '../changepassword/changepassword.model';
export interface Login {
  username: string;
  password: string;

  grant_type: string
  //UserId: number;
  //MobileNo: number;
  //Active: boolean;
}



//const httpOptions = {
//  headers: new HttpHeaders({
//    'Content-Type': 'application/x-www-form-urlencoded',
//    // 'Authorization': 'Bearer ' + localStorage.getItem('token')
//  });


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
    'Authorization': 'Bearer ' + localStorage.getItem('accesstoken')
  })

};

@Injectable()
export class SecurityService {

  apiURL: string;
  constructor(private http: HttpClient) {
    this.apiURL = environment.securityapi;
  }
  ////-------Create Password----------------------
  //createPassword(cp: CreatePassword) {
  //  var body = JSON.stringify(cp);
  //  var headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //  var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
  //  return this.http.post(this.apiURL + "Account/ResetPassword", body, requestOptions).map(x => x.json());
  //}
  ////-------Change Password----------------------
  //ChangePassword(changepassword: ChangePassword) {
  //  var body = JSON.stringify(changepassword);
  //  var headerOptions = new Headers({ 'Content-Type': 'application/json', "Authorization": "Bearer " + localStorage.getItem('token') });
  //  var requestOptions = new RequestOptions({ method: RequestMethod.Post, headers: headerOptions });
  //  return this.http.post(this.apiURL + "Account/ChangePassword", body, requestOptions).map(x => x.arrayBuffer);
  //}
  //---------Login-------------------------------
  login(Login: Login) {

    const httpOptions1 = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    };

    let body = 'username=' + Login.username + '&Password=' + Login.password + '&grant_type=password';
    return this.http.post(this.apiURL + "token", body, httpOptions1)

  }



  ////-------Update entity----------------------
  //putData(entity: any, url: string) {
  //  var body = JSON.stringify(entity);
  //  var headerOptions = new Headers({ 'Content-Type': 'application/json' });
  //  var requestOptions = new RequestOptions({ method: RequestMethod.Put, headers: headerOptions });
  //  return this.http.put(this.apiURL + url,
  //    body,
  //    requestOptions).map(res => res.json());
  //}
  private handleError(error: Response) {
    return Observable.throw(error.statusText);
  }
}
